// extracted by mini-css-extract-plugin
export default {"modal":"bw_l40bl","recipientsSection":"_3VKiEJUr","messageSection":"qa2IMJvd","label":"_27s3MHR8","recipientsList":"_2a2iOfh5","textarea":"ZJ7jEiqx","button":"_8GEk0Y8q"};